import { useEffect } from 'react';

import { useAppDispatch } from '@fd/customHooks/useAppDispatch';
import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { useParams } from 'react-router-dom';

import { appsActions } from '../../../../actions/apps.actions';

/**
 * Keeps `state.currentApp` in step with the `:appId` in the URL after bootstrap (AuthRouter only
 * resolves the app while none is loaded). Used by the legacy BrandSelector and by PortalShell,
 * which does not render BrandSelector.
 */
export const useSyncCurrentAppWithUrl = () => {
  const dispatch = useAppDispatch();
  const currentAppId = useAppSelector((state) => state.currentApp?.AppId);
  const params = useParams<{ appId: string }>();

  useEffect(() => {
    // when we update the url directly, we need to update the current app
    if (params?.appId && params?.appId !== currentAppId) {
      // on first render after login => url is http://portal.flipdish.com/auth0login
      if (params?.appId === 'auth0login' || params?.appId === 'login') {
        return;
      }
      dispatch(appsActions.setCurrentApp(params?.appId));
    }
  }, [currentAppId, params?.appId]);
};
